import { render } from "./Steps.vue?vue&type=template&id=96c1b8f0&scoped=true"
const script = {}

import "./Steps.vue?vue&type=style&index=0&id=96c1b8f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96c1b8f0"]])

export default __exports__